export function compareVersionStrings(a: string, b: string): number {
    const partsA = a.split('.').map((part) => parseInt(part, 10) || 0);
    const partsB = b.split('.').map((part) => parseInt(part, 10) || 0);

    const maxLength = Math.max(partsA.length, partsB.length);

    for (let i = 0; i < maxLength; i++) {
        const numA = partsA[i] || 0;
        const numB = partsB[i] || 0;

        if (numA !== numB) {
            return numA - numB;
        }
    }

    return 0;
}
